'use strict';

module.exports = require( 'ck-core/source/functions/makeLang' )( {
	SEO_TITLE: 'Learn to code Minecraft mods & Roblox games',
	IMPORTANCE_OF_CODE: {
		TITLE: 'Learning to code is important, especially for kids',
		SUBTITLE: 'Get the crucial skill of the 21st century under your belt early',
		BUTTON: 'Watch video'
	},
	SUPPORT_VIDEO: {
		TITLE: 'Get help when you need it',
		DESCRIPTION: "Worried about getting stuck? We're on hand 7 days a week to help with everything from coding questions to account issues. Get in touch with us at any time and our friendly team will get back to you as soon as possible - we promise we can help with any question you might have!"
	},
	PRODUCT_PREVIEW: {
		TITLE: 'Advanced coding tech for kids',
		DESCRIPTION: 'With the Code Kingdoms Code Editor, kids use real Java and Lua code to create their own games and projects in Minecraft and Roblox. Switch at any time between drag-and-drop blocks and text code (like the pros!). Our video course library will show you the ropes, and our Code Editor can track your progress through the courses.'
	},
	COURSE_REVIEW: {
		TITLE: 'All taught through interactive video courses kids love',
		SUBTITLE: 'Explore some of our library containing 100+ hours of content'
	}
} );
